import environment from '@/environment'

/**
 * Relative time range slugs accepted by Explore's `duration` parameter; add others from
 * https://coralogix.com/docs/user-guides/data_exploration/deep-links/ as needed.
 */
export type LogSearchDuration = 'last-15-minutes' | 'last-24-hours' | 'last-2-days'

const coralogixExploreBaseUrl = 'https://sympower.app.eu2.coralogix.com/#/explore'

export function generateLogSearchUrl(filters: string[], duration: LogSearchDuration) {
  const dataPrimeQuery = [
    'source logs',
    `filter $l.applicationname == '${environment.environmentName}'`,
    ...filters.map((filter) => `filter ${filter}`),
  ].join('\n| ')

  return `${coralogixExploreBaseUrl}?queryType=dataprime&duration=${duration}&query=${encodeURIComponent(dataPrimeQuery)}`
}
